module.exports = __webpack_public_path__ + "components/country-flag/static/uz-e640b352fb6683349ac8bd314b4c9986.svg";